export default __webpack_public_path__ + "static/media/4.b8ef53c8.png";